__turbopack_context__.v({
  "className": "uL-pwa_className",
  "variable": "uL-pwa_variable",
});
